import { optimizelyFeatureDecision } from 'store/ui/uiActions';
import { createOptimizelyFeatureDecisionEvent } from '../eventCreators';
import { createOptimizelyFeatureDecisionEventPayload } from '../dataHelpers/createOptimizelyFeatureDecisionEventPayload';

const emitOptimizelyFeatureDecisionEvent = ({ payload }) => {
  const optimizelyFeatureDecisionEvent = createOptimizelyFeatureDecisionEvent(
    createOptimizelyFeatureDecisionEventPayload({
      fxp_variant_string: payload.fxp_variant_string,
      enabled: payload.enabled_string,
    }),
  );

  return optimizelyFeatureDecisionEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [optimizelyFeatureDecision]: emitOptimizelyFeatureDecisionEvent };
